var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSeason(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 84.785,
    height: 86.335,
    viewBox: "0 0 84.785 86.335",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Season",
    transform: "translate(-4.421 -3.45)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_192120",
    "data-name": "Path 192120",
    d: "M85.739,10.844l-1.246.727a8.819,8.819,0,0,0-.679-1.581l1.222-.7a10.836,10.836,0,0,1,.7,1.557Z",
    transform: "translate(-15.985 -1.175)",
    fill: "#c8cfe8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_192121",
    "data-name": "Path 192121",
    d: "M85.739,10.844l-1.246.727a8.819,8.819,0,0,0-.679-1.581l1.222-.7a10.836,10.836,0,0,1,.7,1.557Z",
    transform: "translate(-15.985 -1.175)",
    fill: "#c8cfe8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_192122",
    "data-name": "Path 192122",
    d: "M70.586,10.844l-1.246.727a8.819,8.819,0,0,0-.679-1.581l1.222-.7a10.837,10.837,0,0,1,.7,1.557ZM34.135,35.252a3.829,3.829,0,0,1-1.7,3.522,1.291,1.291,0,0,1-.3.152,3.2,3.2,0,0,1-1.222.24,4.871,4.871,0,0,1-2.4-.711,7.428,7.428,0,0,1-1.014-.735,2.82,2.82,0,0,1,.407-1.517,5.724,5.724,0,0,0,1.326,1.022,2.522,2.522,0,0,0,2.516.327,2.223,2.223,0,0,0,.272-.208v-.016a2.715,2.715,0,0,0,.7-2.077,8.264,8.264,0,0,0-1.094-3.834,8.566,8.566,0,0,0-3.091-3.386,3.331,3.331,0,0,0-1.653-.527,1.955,1.955,0,0,0-.855.208A2.5,2.5,0,0,0,25.046,30a8.589,8.589,0,0,0,1.446,4.409l-1.222.711A10.018,10.018,0,0,1,23.649,30,3.784,3.784,0,0,1,25.334,26.5a3.883,3.883,0,0,1,3.913.327,9.995,9.995,0,0,1,3.61,3.9,9.734,9.734,0,0,1,1.278,4.528ZM86.759,53.661,31.436,85.7,20.007,75.784,8.554,72.493,63.878,40.451l11.453,3.29Z",
    transform: "translate(-0.832 -1.175)",
    fill: "#c8cfe8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_192123",
    "data-name": "Path 192123",
    d: "M8.55,80.346,63.875,48.3,75.33,51.595,20.006,83.639c-3.094-.029-7.2-1.556-11.456-3.292Z",
    transform: "translate(-0.831 -9.031)",
    fill: "#eef0fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_192124",
    "data-name": "Path 192124",
    d: "M20.006,76.622,75.33,44.579,86.758,54.5,31.433,86.542c-4.916-3.121-9.292-6.333-11.427-9.919ZM20.094,45.5,75.419,13.456,63.875,41.288,8.55,73.33c2.042-8.574,6.238-17.987,11.544-27.832Z",
    transform: "translate(-0.831 -2.014)",
    fill: "#c8cfe8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_192125",
    "data-name": "Path 192125",
    d: "M23.027,37.3,78.353,5.255l14.6,52.851L37.628,90.148c-4.308-11-9.431-31.647-14.6-52.85Z",
    transform: "translate(-3.746 -0.363)",
    fill: "#eef0fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_192126",
    "data-name": "Path 192126",
    d: "M91.461,57.947,39.182,88.222l-.562-2.049-.563-2.035h-.006L25.518,38.758,74.1,10.63,75.95,9.563,77.8,8.49Z",
    transform: "translate(-4.248 -1.015)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_192127",
    "data-name": "Path 192127",
    d: "M94.62,57.946,42.342,88.221l-.562-2.049-.569-2.035,41.7-24.148a10.3,10.3,0,0,0,4.768-11.658l-10.415-37.7,1.846-1.067,1.852-1.073L94.62,57.946Z",
    transform: "translate(-7.407 -1.014)",
    fill: "#dce0f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_192128",
    "data-name": "Path 192128",
    d: "M78.8,65,41.781,86.443l-.563-2.035,30.21-17.494A27.491,27.491,0,0,0,84.143,35.809L77.265,10.9l1.846-1.067,8.972,32.474A20.042,20.042,0,0,1,78.8,65Z",
    transform: "translate(-7.409 -1.285)",
    fill: "#eef0fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_192129",
    "data-name": "Path 192129",
    d: "M23.027,37.3,78.353,5.255l2.605,9.432L25.634,46.73A29.772,29.772,0,0,1,23.028,37.3Z",
    transform: "translate(-3.746 -0.363)",
    fill: "#fa3e3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_192130",
    "data-name": "Path 192130",
    d: "M81.5,14.69,26.172,46.732l-.229-.839-.229-.831,53.006-30.7a1.681,1.681,0,0,0,.779-1.9L77.7,5.947l.6-.347.6-.347Z",
    transform: "translate(-4.287 -0.363)",
    fill: "#d82b2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_192131",
    "data-name": "Path 192131",
    d: "M79.726,10.851a4.614,4.614,0,0,1-2.136,5.222L25.943,45.981l-.229-.831,51.047-29.57A4.614,4.614,0,0,0,78.9,10.362L77.7,6.033l.6-.347,1.426,5.164Z",
    transform: "translate(-4.287 -0.45)",
    fill: "#ed3535"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_192132",
    "data-name": "Path 192132",
    d: "M19.281,45.375l14.6,52.852L19.168,85.452,4.421,81.217l14.86-35.842ZM7.719,79.758l11.456,3.29L30.6,92.969,19.263,51.926,7.719,79.756Z",
    transform: "translate(0 -8.441)",
    fill: "#dce0f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_192133",
    "data-name": "Path 192133",
    d: "M33.4,42.018A2.373,2.373,0,0,1,36.636,43.4a2.88,2.88,0,0,1-.819,3.722,2.368,2.368,0,0,1-3.219-1.39A2.872,2.872,0,0,1,33.4,42.018Z",
    transform: "translate(-5.605 -7.713)",
    fill: "#d82b2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_192134",
    "data-name": "Path 192134",
    d: "M37.94,39.492c0,2.607-1.521,3.913-3.219,3.913a4.872,4.872,0,0,1-2.4-.711A7.427,7.427,0,0,1,31.3,41.96a2.82,2.82,0,0,1,.407-1.517,5.724,5.724,0,0,0,1.326,1.022,2.522,2.522,0,0,0,2.516.327,2.224,2.224,0,0,0,.272-.208v-.016a2.715,2.715,0,0,0,.7-2.077,8.264,8.264,0,0,0-1.094-3.834,8.566,8.566,0,0,0-3.091-3.386c-1.868-1.121-3.49-.451-3.49,1.973A8.589,8.589,0,0,0,30.3,38.653l-1.222.711a10.018,10.018,0,0,1-1.621-5.119c0-3.293,2.5-4.945,5.6-3.179a9.995,9.995,0,0,1,3.61,3.9,9.734,9.734,0,0,1,1.278,4.528Z",
    transform: "translate(-4.637 -5.415)",
    fill: "#474746"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_192135",
    "data-name": "Path 192135",
    d: "M44.974,35.293a2.373,2.373,0,0,1,3.239,1.378,2.879,2.879,0,0,1-.819,3.721A2.368,2.368,0,0,1,44.175,39,2.871,2.871,0,0,1,44.974,35.293Z",
    transform: "translate(-7.936 -6.359)",
    fill: "#d82b2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_192136",
    "data-name": "Path 192136",
    d: "M49.512,32.774c0,2.6-1.5,3.915-3.217,3.915a4.709,4.709,0,0,1-2.4-.732,6.672,6.672,0,0,1-1.021-.732,2.788,2.788,0,0,1,.408-1.5,6.158,6.158,0,0,0,1.328,1.022,2.559,2.559,0,0,0,2.519.323c.085-.068.187-.136.272-.2v-.034a2.686,2.686,0,0,0,.7-2.061,8.3,8.3,0,0,0-1.089-3.83,8.574,8.574,0,0,0-3.1-3.386c-1.911-1.148-3.489-.4-3.489,1.974a8.641,8.641,0,0,0,1.462,4.409l-1.232.714a10.06,10.06,0,0,1-1.624-5.123c0-3.342,2.556-4.94,5.6-3.2a10.143,10.143,0,0,1,3.608,3.9,9.99,9.99,0,0,1,1.277,4.544Z",
    transform: "translate(-6.967 -4.061)",
    fill: "#474746"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_192137",
    "data-name": "Path 192137",
    d: "M56.549,28.568a2.373,2.373,0,0,1,3.239,1.378,2.879,2.879,0,0,1-.819,3.721,2.368,2.368,0,0,1-3.219-1.39,2.871,2.871,0,0,1,.8-3.71Z",
    transform: "translate(-10.267 -5.005)",
    fill: "#d82b2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_192138",
    "data-name": "Path 192138",
    d: "M61.085,26.042c0,3.382-2.59,4.93-5.617,3.2a8.079,8.079,0,0,1-1.022-.732A2.805,2.805,0,0,1,54.854,27a6.158,6.158,0,0,0,1.328,1.022,2.517,2.517,0,0,0,2.519.323,2.915,2.915,0,0,0,.289-.2V28.12a2.8,2.8,0,0,0,.681-2.077,8.3,8.3,0,0,0-1.089-3.83A8.666,8.666,0,0,0,55.5,18.826c-1.969-1.149-3.49-.393-3.49,1.974a8.869,8.869,0,0,0,1.449,4.433l-1.23.712A10.148,10.148,0,0,1,50.6,20.8c0-3.316,2.533-4.936,5.6-3.183a10.024,10.024,0,0,1,3.608,3.9,9.716,9.716,0,0,1,1.277,4.528Z",
    transform: "translate(-9.297 -2.708)",
    fill: "#474746"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_192139",
    "data-name": "Path 192139",
    d: "M68.144,21.843a2.372,2.372,0,0,1,3.239,1.378,2.879,2.879,0,0,1-.819,3.721,2.368,2.368,0,0,1-3.219-1.39A2.871,2.871,0,0,1,68.144,21.843Z",
    transform: "translate(-12.601 -3.651)",
    fill: "#d82b2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_192140",
    "data-name": "Path 192140",
    d: "M72.679,19.317c0,3.382-2.589,4.93-5.617,3.2a8.076,8.076,0,0,1-1.021-.732,2.8,2.8,0,0,1,.409-1.515,6.154,6.154,0,0,0,1.327,1.022,2.517,2.517,0,0,0,2.519.323,2.922,2.922,0,0,0,.29-.2v-.017a2.793,2.793,0,0,0,.68-2.077,8.292,8.292,0,0,0-1.089-3.83A8.662,8.662,0,0,0,67.1,12.1c-1.968-1.148-3.489-.392-3.489,1.974a8.893,8.893,0,0,0,1.454,4.437l-1.23.712a10.178,10.178,0,0,1-1.636-5.149c0-3.316,2.533-4.936,5.6-3.183a10.026,10.026,0,0,1,3.609,3.9,9.722,9.722,0,0,1,1.276,4.528Z",
    transform: "translate(-11.632 -1.354)",
    fill: "#474746"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_192141",
    "data-name": "Path 192141",
    d: "M79.738,15.118A2.373,2.373,0,0,1,82.977,16.5a2.88,2.88,0,0,1-.819,3.722,2.368,2.368,0,0,1-3.219-1.39,2.87,2.87,0,0,1,.8-3.71Z",
    transform: "translate(-14.935 -2.297)",
    fill: "#d82b2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_192142",
    "data-name": "Path 192142",
    d: "M84.274,12.592c0,2.62-1.5,3.915-3.217,3.915a4.853,4.853,0,0,1-2.4-.715,8.076,8.076,0,0,1-1.021-.732,2.8,2.8,0,0,1,.408-1.515,6.128,6.128,0,0,0,1.328,1.021,2.516,2.516,0,0,0,2.519.323,2.914,2.914,0,0,0,.289-.2v-.017a2.793,2.793,0,0,0,.681-2.077,8.3,8.3,0,0,0-1.089-3.83A8.674,8.674,0,0,0,78.69,5.375c-1.969-1.148-3.49-.393-3.49,1.974a8.912,8.912,0,0,0,1.465,4.438l-1.25.724a10.209,10.209,0,0,1-1.627-5.163c0-3.316,2.533-4.936,5.6-3.183A10.018,10.018,0,0,1,83,8.064a9.714,9.714,0,0,1,1.277,4.528Z",
    transform: "translate(-13.966 0)",
    fill: "#474746"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_192143",
    "data-name": "Path 192143",
    d: "M55.411,50.065a4.861,4.861,0,0,1,3.667-.789,3.566,3.566,0,0,1,2.327,2.417,5.034,5.034,0,0,1,.331,2.875,5.525,5.525,0,0,1-1.066,2.267,3.614,3.614,0,0,1,2.338.187,3.9,3.9,0,0,1,1.9,2.393,5.073,5.073,0,0,1-.067,4.062,6.877,6.877,0,0,1-2.958,3.136,9.176,9.176,0,0,1-4.172,1.277.743.743,0,0,1-.475-.13,1.01,1.01,0,0,1-.335-.474,1.326,1.326,0,0,1-.05-.8.884.884,0,0,1,.407-.592.863.863,0,0,1,.384-.108A7.085,7.085,0,0,0,60.8,64.778,6.31,6.31,0,0,0,62.986,62.8a2.684,2.684,0,0,0,.22-2.547q-1.112-2.916-5.149-.585l-.292.169a.665.665,0,0,1-.65.024.952.952,0,0,1-.493-.551,1.285,1.285,0,0,1-.03-.818.946.946,0,0,1,.431-.6l.109-.064a6.46,6.46,0,0,0,2.525-2.319,3.017,3.017,0,0,0,.169-2.652,1.962,1.962,0,0,0-1.4-1.339,3.408,3.408,0,0,0-2.4.6,7.581,7.581,0,0,0-2.543,2.4,1.048,1.048,0,0,1-.291.283.608.608,0,0,1-.568.032.813.813,0,0,1-.434-.5,1.122,1.122,0,0,1,.064-1,8.936,8.936,0,0,1,3.163-3.268Z",
    transform: "translate(-9.599 -9.204)",
    fill: "#3d9bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_192144",
    "data-name": "Path 192144",
    d: "M65.63,63.479a6.873,6.873,0,0,1-2.957,3.135c-.138.078-.276.157-.419.229a6.827,6.827,0,0,0,2.755-3.011,5.09,5.09,0,0,0,.065-4.064,3.929,3.929,0,0,0-1.9-2.4,3.618,3.618,0,0,0-2.336-.183A5.514,5.514,0,0,0,61.9,54.919a5.053,5.053,0,0,0-.334-2.873,3.575,3.575,0,0,0-2.324-2.415,4.522,4.522,0,0,0-3.227.549c.06-.046.125-.078.184-.117a4.851,4.851,0,0,1,3.666-.786,3.547,3.547,0,0,1,2.329,2.415,5.054,5.054,0,0,1,.334,2.873,5.645,5.645,0,0,1-1.066,2.271,3.608,3.608,0,0,1,2.336.184,3.906,3.906,0,0,1,1.9,2.394,5.1,5.1,0,0,1-.072,4.064Z",
    transform: "translate(-10.388 -9.204)",
    fill: "#2b87dc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_192145",
    "data-name": "Path 192145",
    d: "M71.182,41.571a.772.772,0,0,1,.748-.034,1.1,1.1,0,0,1,.554.644l4.992,13.077,1.809-1.045a.682.682,0,0,1,.668-.035.989.989,0,0,1,.5.573,1.271,1.271,0,0,1,.034.83.99.99,0,0,1-.453.6L74.39,59.439a.672.672,0,0,1-.651.039.968.968,0,0,1-.487-.567,1.332,1.332,0,0,1-.048-.836.922.922,0,0,1,.435-.6l2.176-1.256L71.336,44.482l-1.422,2.228a1.31,1.31,0,0,1-.37.383.69.69,0,0,1-.672.051,1.006,1.006,0,0,1-.492-.592,1.316,1.316,0,0,1,.112-1.224l1.859-3.075a1.3,1.3,0,0,1,.447-.46l.383-.222Z",
    transform: "translate(-12.857 -7.652)",
    fill: "#3d9bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_192146",
    "data-name": "Path 192146",
    d: "M80.943,55.579a.972.972,0,0,1-.406.569,1.245,1.245,0,0,0-.052-.74,1.008,1.008,0,0,0-.5-.575.693.693,0,0,0-.668.032l-1.134.657a.661.661,0,0,1-.95-.336l-4.715-12.35a1.077,1.077,0,0,0-.557-.641.759.759,0,0,0-.746.033l-.386.223a1.021,1.021,0,0,0-.288.248l.268-.445a1.312,1.312,0,0,1,.445-.458l.387-.222a.759.759,0,0,1,.746-.033,1.075,1.075,0,0,1,.557.641l4.993,13.076,1.806-1.047a.693.693,0,0,1,.668-.033,1.007,1.007,0,0,1,.5.576,1.272,1.272,0,0,1,.033.825Z",
    transform: "translate(-13.312 -7.652)",
    fill: "#2b87dc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_192154",
    "data-name": "Path 192154",
    d: "M19.028,53.083,22.2,51.926c.562-1.148.26-3.9.018-6.543l-3.193,7.7Z",
    transform: "translate(-2.941 -8.442)",
    fill: "#d82b2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_192155",
    "data-name": "Path 192155",
    d: "M23.022,45.383,23,51.926l2.624,2.883Z",
    transform: "translate(-3.741 -8.443)",
    fill: "#ed3535"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_192156",
    "data-name": "Path 192156",
    d: "M28.97,47.893a1.627,1.627,0,0,0-1.628,1.628,1.625,1.625,0,0,0-1.628-1.628,1.625,1.625,0,0,0,1.628-1.628,1.625,1.625,0,0,0,1.628,1.628Z",
    transform: "translate(-4.287 -8.62)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeason);
export default __webpack_public_path__ + "static/media/Season.22891b39b018a5807e487d79ab43c08e.svg";
export { ForwardRef as ReactComponent };